export default __webpack_public_path__ + "static/media/Gilroy-Bold.ca49f765.ttf";